export default __webpack_public_path__ + "static/media/B2_32.0e6b8571.mp3";